import { Feature } from 'types/user'

export type PaymentBlockingReason = 'blocked' | 'insufficientBalance' | 'limitExceeded'

export function getPaymentBlockingReason(features?: { [key in Feature]?: any }): PaymentBlockingReason | null {
  const paymentState = features?.[Feature.PAYMENT_STATE]

  if (paymentState === 'blocked') return 'blocked'
  if (paymentState === 'insufficientBalance') return 'insufficientBalance'
  if (paymentState === 'limitExceeded') return 'limitExceeded'

  return null
}
